export default {
    'chat.title': 'Messages',
    'chat.type.influencers': 'Influencers',
    'chat.type.p2p': 'Post2Post',
    'notification.action.read.all': 'Click here to read all notifications. sdgds',
    'notification.info.not-found': 'No notifications found! sdgsdgs'
};